var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [_vm._v("Add")]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _vm.step === 1
                    ? _c("div", [
                        _c("div", { staticStyle: { "overflow-x": "hidden" } }, [
                          _c("label", [
                            _vm._v(
                              "Insert as many respondent names as you like, with each on a new line"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.NamesOrEmails,
                                expression: "NamesOrEmails",
                                modifiers: { trim: true },
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              rows: "8",
                              placeholder: "you can copy and paste here",
                            },
                            domProps: { value: _vm.NamesOrEmails },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.NamesOrEmails = $event.target.value.trim()
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step === 2
                    ? _c(
                        "div",
                        _vm._l(_vm.ProjectUsers, function (p) {
                          return _c(
                            "div",
                            {
                              key: p.LocalId,
                              staticClass: "row",
                              staticStyle: { "margin-bottom": "3px" },
                            },
                            [
                              _c("div", { staticClass: "col-md-4" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim",
                                      value: p.Name,
                                      expression: "p.Name",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Required name",
                                  },
                                  domProps: { value: p.Name },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        p,
                                        "Name",
                                        $event.target.value.trim()
                                      )
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-4" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim",
                                      value: p.Email,
                                      expression: "p.Email",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "email",
                                    placeholder: "Optional email",
                                  },
                                  domProps: { value: p.Email },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        p,
                                        "Email",
                                        $event.target.value.trim()
                                      )
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-4" },
                                _vm._l(p.Tags, function (t) {
                                  return _c(
                                    "span",
                                    {
                                      key: t,
                                      staticClass: "badge badge-secondary",
                                    },
                                    [_vm._v(_vm._s(t))]
                                  )
                                }),
                                0
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _vm.step === 1
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          on: { click: _vm.preview },
                        },
                        [_vm._v("Preview")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step === 2
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: { disabled: _vm.operationInProgress },
                          on: { click: _vm.back },
                        },
                        [_vm._v("Back")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step === 2
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: {
                            disabled: _vm.operationInProgress,
                            type: "button",
                          },
                          on: { click: _vm.handleCreateProjectUsers },
                        },
                        [
                          _vm.operationInProgress
                            ? _c("span", [
                                _c("i", {
                                  staticClass: "fa fa-spinner fa-spin",
                                }),
                                _vm._v(" Please wait..."),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.operationInProgress
                            ? _c("span", [_vm._v("Save")])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }